import { generateApiRoute } from '@klp/core/api/helpers';
import { generatePath } from '@klp/routing';

const byggDokumentsApiName = generatePath('bygg', 'byggtegning');

export const byggDokumentsApiRoutes = {
    list: (byggNummer: string) =>
        generateApiRoute([byggDokumentsApiName, 'byggnummer', byggNummer]),
};
